// src/pages/auth/ForgotPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../../components/AuthLayout';
import MessageBox from '../../components/MessageBox';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);

  const handleReset = () => {
    if (email.trim() === '') {
      setMessage({ type: 'error', text: 'Please enter your email.' });
    } else {
      setMessage({ type: 'success', text: 'Reset link sent to your email.' });
    }
  };

  return (
    <AuthLayout title="Reset Admin Password">
      {message && (
        <MessageBox
          type={message.type}
          message={message.text}
          onClose={() => setMessage(null)}
        />
      )}
      <input
        type="email"
        placeholder="Admin Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={styles.input}
      />
      <button style={styles.button} onClick={handleReset}>
        Send Reset Link
      </button>
      <div style={styles.footer}>
        <Link to="/" style={styles.link}>
          Back to Login
        </Link>
      </div>
    </AuthLayout>
  );
}

const styles = {
  input: {
    width: '100%',
    padding: 12,
    marginBottom: 15,
    border: '1px solid #E6D8BE',
    borderRadius: 8,
    backgroundColor: '#FFFDF7',
    color: '#0F3D2E',
  },
  button: {
    width: '100%',
    padding: 12,
    backgroundColor: '#C9A14A',
    color: '#0F3D2E',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: 16,
    marginTop: 10,
  },
  footer: {
    marginTop: 20,
    textAlign: 'center',
    fontSize: 14,
  },
  link: {
    color: '#0F3D2E',
    textDecoration: 'none',
  },
};
